import { IoIosSearch, IoMdClose } from "react-icons/io";
import { LuClock } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const SearchModal = ({
  setOpenSuggest,
  searchModalRef,
  search,
  dataHistory,
  dataSearch,
  loadingSearch,
  mutateDelete,
  isLogin,
}) => {
  const navigate = useNavigate();

  return (
    <div
      ref={searchModalRef}
      className="absolute top-12 left-0 right-0 bg-white shadow-lg rounded-xl p-4 border border-gray-300 z-50 max-h-96 overflow-y-auto hide-scrollbar"
    >
      <div className="flex flex-col gap-4">
        {(search === "" || search === null) &&
        dataHistory &&
        dataHistory?.search_history.length > 0 ? (
          dataHistory?.search_history.map((item, i) => (
            <div
              key={i}
              className="flex items-center justify-between py-1 cursor-pointer"
              onClick={() =>
                navigate(`/purchase/search-product/${item.keyword}`)
              }
            >
              <div className="flex items-center gap-2 text-slate-500 hover:text-primary">
                <LuClock size={16} />
                <p className="text-md">{item.keyword}</p>
              </div>
              <IoMdClose
                onClick={(e) => {
                  e.stopPropagation();
                  mutateDelete(item.search_id);
                }}
                size={16}
                className="text-gray-500"
              />
            </div>
          ))
        ) : (search !== "" || search !== null) &&
          dataSearch &&
          dataSearch?.length > 0 ? (
          dataSearch?.map((item, i) => (
            <div
              key={i}
              className="flex items-center justify-between py-1 cursor-pointer"
              onClick={() => navigate(`/purchase/product-detail/${item.id}`)}
            >
              <div className="flex items-center gap-2 text-slate-500 hover:text-primary">
                <IoIosSearch size={16} />
                <p className="text-md">{item.name}</p>
              </div>
            </div>
          ))
        ) : loadingSearch ? (
          <p className="text-md text-slate-500 italic px-2 py-1 animate-pulse">
            Memuat...
          </p>
        ) : !isLogin ? (
          <p className="text-md text-slate-500 italic px-2 py-1">
            Silahkan cari produk yang diinginkan
          </p>
        ) : (
          <p className="text-md text-slate-500 italic px-2 py-1">
            Tidak ada hasil
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchModal;
